var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaritalStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FDF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 17.3333C21.6597 16.36 22.6663 15.1933 22.6663 13.6667C22.6663 12.6942 22.28 11.7616 21.5924 11.0739C20.9048 10.3863 19.9721 10 18.9997 10C17.8263 10 16.9997 10.3333 15.9997 11.3333C14.9997 10.3333 14.173 10 12.9997 10C12.0272 10 11.0946 10.3863 10.4069 11.0739C9.71932 11.7616 9.33301 12.6942 9.33301 13.6667C9.33301 15.2 10.333 16.3667 11.333 17.3333L15.9997 22L20.6663 17.3333Z",
    stroke: "#E60076",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaritalStatus);
export default __webpack_public_path__ + "static/media/maritalStatus.161ee35157413f739a25be908b8dfe98.svg";
export { ForwardRef as ReactComponent };